import { Dispatch } from 'redux';

import { getCurrentUserSubscription } from 'store/actionCreators/subscriptions';
import { UserSubscription } from 'types';

export function isRenderableUserSubscription(
  subscription?: UserSubscription | null,
): boolean {
  if (!subscription?.id) return false;
  return (
    typeof subscription.maxMembers === 'number' &&
    typeof subscription.maxCommunities === 'number' &&
    typeof subscription.maxGroups === 'number' &&
    typeof subscription.maxStorage === 'number'
  );
}

/** Refetch subscription from API after websocket billing events. */
export function syncSubscriptionFromWsEvent(dispatch: Dispatch): void {
  dispatch(getCurrentUserSubscription.trigger());
}
